// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__-Sf31","fieldsetLegend":"Fieldset_fieldsetLegend__33dOO","fieldsetContent":"Fieldset_fieldsetContent__JoRYO"};